import { useState, useEffect, useRef } from "react";
import * as React from "react";
import { LineChart } from "@mui/x-charts/LineChart";
import Cookies from "js-cookie";

const COLOR_PALETTE = [
  "#3b82f6",
  "#ef4444",
  "#10b981",
  "#f59e0b",
  "#8b5cf6",
  "#ec4899",
  "#06b6d4",
  "#f97316",
  "#14b8a6",
  "#6366f1",
  "#d946ef",
  "#84cc16",
  "#22d3ee",
  "#fb7185",
  "#34d399",
  "#fbbf24",
  "#a855f7",
  "#60a5fa",
  "#f43f5e",
  "#2dd4bf",
  "#4f46e5",
  "#c026d3",
  "#4ade80",
  "#e11d48",
  "#2563eb",
  "#dc2626",
  "#059669",
  "#d97706",
  "#7c3aed",
  "#db2777",
  "#0891b2",
  "#ea580c",
  "#0d9488",
  "#4f46e5",
  "#c026d3",
  "#65a30d",
  "#06b6d4",
  "#f43f5e",
  "#10b981",
  "#fbbf24",
  "#8b5cf6",
  "#3b82f6",
  "#ef4444",
  "#f59e0b",
  "#ec4899",
  "#84cc16",
  "#22d3ee",
  "#fb7185",
  "#d946ef",
  "#6366f1",
  "#14b8a6",
  "#f97316",
  "#06b6d4",
  "#34d399",
  "#a855f7",
  "#60a5fa",
  "#2dd4bf",
  "#4ade80",
  "#e11d48",
  "#2563eb",
  "#dc2626",
];

export default function ViewdetailGraph2({
  playersc,
  otherplayername,
  allplayerweeklyscores,
  isOtherDivOpen,
  playerweeklyscores,
  otherplayerweeklyscores,
}) {
  const [alldata, setAlldata] = useState([]);
  const [pData, setPdata] = useState([]); // login player scores
  const [uData, setUData] = useState([]); // other player scores
  const [chartWidth, setChartWidth] = useState(0);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;
    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        setChartWidth(entry.contentRect.width);
      }
    });
    resizeObserver.observe(containerRef.current);
    return () => resizeObserver.disconnect();
  }, []);

  const loginp_name = Cookies.get("name") || "Me";
  const allusername = playersc?.map((player) => player?.userName).flat();

  // Process X labels (Weeks) - Ensure we cover the longest series
  const xLabels = [];
  const maxWeeksArr = [
    ...(allplayerweeklyscores?.map((p) => p.scores?.length || 0) || []),
    playerweeklyscores?.length || 0,
    otherplayerweeklyscores?.length || 0,
  ];
  const maxWeeks = Math.max(0, ...maxWeeksArr);

  for (let i = 1; i <= maxWeeks; i++) {
    xLabels.push("Week " + i);
  }

  // Dynamic Layout Adjustment: Calculate margin based on legend rows
  // Estimate: 110px per legend item, 30px per row
  const legendRows = Math.ceil(
    ((allusername?.length || 0) * 110) / (chartWidth || 900),
  );
  const dynamicTopMargin = Math.max(40, legendRows * 50);
  const dynamicHeight = 555 + Math.max(0, dynamicTopMargin - 40);

  // Calculate Y labels range (for axis scaling if needed, though MUI does it)
  const yLabels = [];
  allplayerweeklyscores?.forEach((player) => {
    player?.scores?.forEach((score) => {
      yLabels.push(score?.finalScore);
    });
  });

  useEffect(() => {
    if (!allplayerweeklyscores) return;

    const processedData = allplayerweeklyscores.map((player) =>
      player.scores.map((s) => s.finalScore),
    );
    setAlldata(processedData);
  }, [allplayerweeklyscores]);

  useEffect(() => {
    if (playerweeklyscores) {
      setPdata(playerweeklyscores.map((s) => s.finalScore));
    }
    if (otherplayerweeklyscores) {
      setUData(otherplayerweeklyscores.map((s) => s.finalScore));
    }
  }, [playerweeklyscores, otherplayerweeklyscores]);

  const handlePointClick = (event, params) => {
    const { seriesId, dataIndex } = params;
    console.log(
      `Clicked on point: Series ${seriesId}, Week Index ${dataIndex}`,
    );
    // You could trigger a custom action here, like a toast or modal
  };

  const commonProps = {
    width: chartWidth,
    height: dynamicHeight,
    margin: { top: dynamicTopMargin, right: 30, bottom: 50, left: 50 },
    onMarkClick: handlePointClick,
    slotProps: {
      legend: {
        direction: "row",
        position: { vertical: "top", horizontal: "middle" },
        padding: 0,
      },
    },
    sx: {
      ".MuiLineElement-root": {
        strokeWidth: 2,
      },
      ".MuiAreaElement-root": {
        fillOpacity: 0.8,
      },
      ".MuiMarkElement-root": {
        fill: "#000",
        strokeWidth: 2,
        scale: "1.2",
        transition: "scale 0.2s",
        "&:hover": {
          scale: "1.5",
        },
      },
      "& .MuiChartsAxis-bottom .MuiChartsAxis-line": {
        stroke: "#fff",
      },
      "& .MuiChartsAxis-left .MuiChartsAxis-line": {
        stroke: "#fff",
      },
      "& .MuiChartsAxis-bottom .MuiChartsAxis-tick": {
        stroke: "#fff",
      },
      "& .MuiChartsAxis-left .MuiChartsAxis-tick": {
        stroke: "#fff",
      },
      "& .MuiChartsLegend-root text": {
        fill: "#fff !important",
      },
    },
  };

  return (
    <div
      ref={containerRef}
      className="score_graph"
      style={{
        backgroundColor: "#000",
        padding: "20px",
        borderRadius: "8px",
        width: "100%",
        overflow: "hidden",
      }}
    >
      {chartWidth > 0 &&
        (!isOtherDivOpen ? (
          <LineChart
            {...commonProps}
            colors={COLOR_PALETTE}
            series={alldata?.map((data, index) => ({
              id: `series-${index}`,
              data: data,
              label: allusername[index] || `Player ${index + 1}`,
              showMark: true,
              curve: "catmullRom",
              area: true,
              stack: "total",
              highlightScope: { faded: "global", highlighted: "series" },
            }))}
            xAxis={[
              {
                scaleType: "point",
                data: xLabels,
                label: "Weekly Progress",
                labelStyle: { fill: "#fff" },
                tickLabelStyle: { fill: "#fff" },
              },
            ]}
            yAxis={[
              {
                label: "Scores",
                labelStyle: { fill: "#fff" },
                tickLabelStyle: { fill: "#fff" },
              },
            ]}
          />
        ) : (
          <LineChart
            {...commonProps}
            colors={COLOR_PALETTE}
            series={[
              {
                id: "login-player",
                data: pData,
                label: loginp_name,
                curve: "catmullRom",
                area: true,
                stack: "comparison",
                highlightScope: { faded: "global", highlighted: "series" },
              },
              {
                id: "other-player",
                data: uData,
                label: otherplayername,
                curve: "catmullRom",
                area: true,
                stack: "comparison",
                highlightScope: { faded: "global", highlighted: "series" },
              },
            ]}
            xAxis={[
              {
                scaleType: "point",
                data: xLabels,
                label: "Weekly Comparison",
                labelStyle: { fill: "#fff" },
                tickLabelStyle: { fill: "#fff" },
              },
            ]}
            yAxis={[
              {
                label: "Scores",
                labelStyle: { fill: "#fff" },
                tickLabelStyle: { fill: "#fff" },
              },
            ]}
          />
        ))}
    </div>
  );
}
